import React from 'react';
import { Modal } from 'react-bootstrap';
import ButtonComponent from './ButtonComponent';   

const ErrorModal = ({ show, onClose, title, message }) => {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title className="ms-3">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message || "حدث خطأ"}  
      </Modal.Body>
      <Modal.Footer>
        <ButtonComponent text="إغلاق" className="primary-bg" onClick={onClose} />
      </Modal.Footer>
    </Modal>
  );
}

export default ErrorModal;